import WebAppProvider, { useWebAppContext } from "./WebAppProvider.js";

export { WebAppProvider, useWebAppContext };
